import React from 'react';
import {
  tableClassName,
  tableHeadClassName,
  tableHeaderCellClassName,
  tableBodyClassName,
  tableRowClassName,
  tableCellClassName,
  tableCellPrimaryClassName,
  tableHeaderAlignClass,
} from './formStyles';

function Table({ children, className = '', wrap = true, zebra = false }) {
  const table = (
    <table className={`${tableClassName} ${zebra ? 'table-zebra' : ''} ${className}`.trim()}>
      {children}
    </table>
  );

  if (!wrap) {
    return table;
  }

  return (
    <div className="table-shell card-premium overflow-hidden">
      <div className="overflow-x-auto">{table}</div>
    </div>
  );
}

function TableHead({ children, className = '', sticky = true }) {
  return (
    <thead
      className={`${tableHeadClassName} ${sticky ? 'table-head-sticky' : ''} ${className}`.trim()}
    >
      {children}
    </thead>
  );
}

function TableBody({ children, className = '' }) {
  return <tbody className={`${tableBodyClassName} ${className}`.trim()}>{children}</tbody>;
}

function TableRow({ children, className = '' }) {
  return <tr className={`${tableRowClassName} ${className}`.trim()}>{children}</tr>;
}

function TableHeaderCell({ children, align = 'left', className = '' }) {
  return (
    <th
      className={`${tableHeaderCellClassName} ${tableHeaderAlignClass(align)} ${className}`.trim()}
    >
      {children}
    </th>
  );
}

function TableCell({ children, align = 'left', primary = false, truncate = false, title, className = '' }) {
  const base = primary ? tableCellPrimaryClassName : tableCellClassName;
  const content = truncate ? (
    <span className="block truncate" title={title || (typeof children === 'string' ? children : undefined)}>
      {children}
    </span>
  ) : (
    children
  );

  return (
    <td className={`${base} ${tableHeaderAlignClass(align)} ${className}`.trim()}>
      {content}
    </td>
  );
}

export { Table, TableHead, TableBody, TableRow, TableHeaderCell, TableCell };
export default Table;
